import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { MailSuccessDialog } from '@/components/ui/mail-success-dialog';
import { TextArea } from '@/components/ui/textarea';
import NetworkService from '@/services/network.service';
import InfoJson from '@/config/info.json';
import { ChangeEvent, FormEvent, useState } from 'react';

import MailJson from '@/config/mail.json';
import { sentryCaptureException } from '@/utility';

export function PersonContactForm() {
  const [form, setForm] = useState({
    email: '',
    phoneNumber: '',
    name: '',
    permission: false,
    description: '',
  });
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      setLoading(true);

      const client = new NetworkService();
      await client.post('/api/mail', {
        name: form.name,
        email: form.email,
        phoneNumber: form.phoneNumber,
        message: form.description,
        text: `${form.name} has submitted a contact form!`,
        subject: `${InfoJson.name} : ${form.name} contacted you!`,
        templateId: 'personContact',
      });

      setForm({
        description: '',
        email: '',
        name: '',
        permission: false,
        phoneNumber: '',
      });

      setLoading(false);
      setOpen(true);
    } catch (err) {
      setLoading(false);
      sentryCaptureException(err);
    }
  };

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <form className="max-w-5xl mx-auto space-y-5" onSubmit={handleSubmit}>
      <Input
        placeholder="Your name *"
        required
        value={form.name}
        name="name"
        onChange={handleChange}
        variant="default"
      />
      <Input
        type="email"
        placeholder="Your email address *"
        required
        value={form.email}
        name="email"
        onChange={handleChange}
        variant="default"
      />
      <Input
        placeholder="Phone Number*"
        onChange={handleChange}
        name="phoneNumber"
        value={form.phoneNumber}
        variant="default"
        required
      />
      <TextArea
        placeholder="How can we help? *"
        rows={4}
        className="resize-none"
        required
        value={form.description}
        name="description"
        onChange={handleChange}
      />
      <div className="max-w-xl mx-auto">
        <div className="flex items-start space-x-1">
          <div className="mt-2">
            <input
              type="checkbox"
              name=""
              checked={form.permission}
              id="allow"
              required
              onChange={() =>
                setForm((prev) => ({ ...prev, permission: !prev.permission }))
              }
              className="fill-current bg-white"
            />
          </div>
          <label htmlFor="allow" className="text-center">
            By submitting your message and personal details you are permitting
            us to contact you by these means in response to your inquiry.
          </label>
        </div>
        <Button
          className="font-semibold w-full mt-4"
          disabled={!form.permission || loading}
          loading={loading}
        >
          Contact Me
        </Button>
        <MailSuccessDialog
          isOpen={open}
          toggleModal={() => setOpen((prev) => !prev)}
          title={MailJson['contact-form'].mail.title}
          description={MailJson['contact-form'].mail['description']}
        />
      </div>
    </form>
  );
}
